"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportUserQuantity = exports.CustomerCareSchema = exports.CustomerCarePlan = exports.Channel = void 0;
const Joi = __importStar(require("joi"));
var Channel;
(function (Channel) {
    Channel["ServiceDesk"] = "SERVICE_DESK";
    Channel["Email"] = "EMAIL";
    Channel["Phone"] = "PHONE";
})(Channel || (exports.Channel = Channel = {}));
var CustomerCarePlan;
(function (CustomerCarePlan) {
    CustomerCarePlan["Standard"] = "STANDARD";
    CustomerCarePlan["Premium"] = "PREMIUM";
    CustomerCarePlan["Enterprise"] = "ENTERPRISE";
    CustomerCarePlan["Custom"] = "CUSTOM";
})(CustomerCarePlan || (exports.CustomerCarePlan = CustomerCarePlan = {}));
exports.CustomerCareSchema = Joi.object({
    type: Joi.string()
        .valid(...Object.values(CustomerCarePlan))
        .required(),
    monthlyPrice: Joi.number().required(),
    supportUserIds: Joi.array().items(Joi.string()).required(),
    details: Joi.any(),
});
const supportUserQuantity = {
    [CustomerCarePlan.Enterprise]: 10,
    [CustomerCarePlan.Premium]: 3,
    [CustomerCarePlan.Standard]: 1,
};
const getSupportUserQuantity = (customerCare) => {
    return (supportUserQuantity[customerCare.type] ||
        (customerCare.type === CustomerCarePlan.Custom
            ? customerCare.details.quantitySupportUsers
            : 0));
};
exports.getSupportUserQuantity = getSupportUserQuantity;
//# sourceMappingURL=index.js.map